export const mapStylesProp = ({ styles = {} }) => {
    // Destructure styles from object param, set default value to empty object
    // If styles is an array, we need to map it into the object we'll return
    if (Array.isArray(styles)) {
        return styles.reduce((styleObj, style) => ({ ...styleObj, ...mapStylesProp({ styles: style }) }), {});
    }

    return styles;
};
